import React from "react";
import { withSitecoreContext, RichText, Placeholder } from "@sitecore-jss/sitecore-jss-react";
import { ComponentProps } from "../../types/types";
import { bindPropsToComponentFields } from "../../utils/dochubUtils";
import "../../../node_modules/react-eplr/dist/style.css" //added this import in order to fix font issue caused by chunck optimization
import "../CardModuleLinkedItem/index.scss"; //added this import in order to fix font issue on Dochub caused by chunck optimization 
import "./index.scss";
import { TextModuleModel } from "./models/TextModule.model";

interface TextModuleProps extends ComponentProps {}

const TextingModule = (props: TextModuleProps) => {
  if (props?.paramsFields) {
    bindPropsToComponentFields(props, props?.paramsFields);
  }
  const model = new TextModuleModel(props);
  const themeOption = props?.params?.Theme;
  const tagTitle = props?.fields?.["Tag Title"]?.value;
  const strongTitle = props?.fields?.["Strong Title"]?.value;
  const fullWidth = props?.fields?.["fullWidth"]?.value;
  const isEE = props.sitecoreContext?.pageEditing;
  const isRtl = props?.sitecoreContext?.ContextExtensions?.isRTL;
  const marginTop = props?.params?.TopMargin ? `margin-top__${props?.params?.TopMargin}` : "";
  const marginBottom = props?.params?.BottomMargin ? `margin-bottom__${props?.params?.BottomMargin}` : "";

  return (
    <>
      {props.fields && (
        <section
          className={`container texting-module texting-module--${themeOption} texting-module--${isRtl ? model?.textPosition?.value || "right" : model?.textPosition?.value || "left"} ${
            isRtl ? "texting-module__rtl" : ""
          } ${marginTop} ${marginBottom}`}
          id={props?.rendering?.dataSource}
        >
          <div className={`texting-module__content texting-module__content--${fullWidth ? "fullWidth" : ""}`}>
            {model?.title ? (
              <RichText
                field={model?.title}
                className={"texting-module__title"}
                tag={tagTitle}
                style={strongTitle === true ? { fontWeight: "bold" } : { fontWeight: "300" }}
              />
            ) : null}

            <RichText tag="div" field={model?.description} className={"texting-module__text"} />
          </div>
          <div className="placeholder">
            <Placeholder name="jss-button" rendering={props.rendering} />
          </div>
        </section>
      )}
    </>
  );
};

export default withSitecoreContext()(TextingModule);
